import { FormCentralizer, Loading } from '@/components';
import { useId } from '@/hooks';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { UserForm } from '../_components/UserForm';
import { useUpdateUser } from '../_hooks/user';
import { useUser } from '../_hooks/user';

export const UpdateUserPage: FC = () => {
  const navigate = useNavigate();
  const { openMessage } = useMessage();
  const { t } = useTranslation();
  const { id } = useId();
  const { mutateAsync: updateUser } = useUpdateUser();
  const user = useUser(id);

  if (user.isPending || !user.data) {
    return <Loading />;
  }

  return (
    <FormCentralizer>
      <UserForm
        initialValues={{
          name: user.data.name,
          email: user.data.email,
          isEmailNotificationEnabled: user.data.isEmailNotificationEnabled,
        }}
        isEditing={true}
        onSubmit={async (values) => {
          try {
            await updateUser({
              ...values,
              id,
            });

            await Promise.all([
              openMessage('success', t('message-save-completed')),
              (async () => {
                navigate(`/tenant-manager/users/${id}`, { replace: true });
              })(),
            ]);
          } catch {
            await openMessage('error', t('message-save-failed'));
          }
        }}
      />
    </FormCentralizer>
  );
};
